import Axios from "axios";

export const getCountries = async () => {
  const response = await Axios.get("https://restcountries.eu/rest/v2/all");
  return response.data;
};
